/**
 * POMME Redesign — Shared JS
 * Loaded conditionally from theme.liquid when settings.pomme_enable_redesign is true.
 * Vanilla JS, zero dependency. Self-init on DOMContentLoaded.
 * All functions live under window.Pomme namespace to avoid conflicts.
 */
(function () {
  'use strict';

  var Pomme = window.Pomme || {};
  window.Pomme = Pomme;

  /* ------- Popup helpers ------- */
  Pomme.openPopup = function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  };
  Pomme.closePopup = function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  /* ------- Copy code helper ------- */
  Pomme.copyCode = function (btn) {
    var code = btn.dataset.code || btn.textContent.trim();
    var done = function () {
      btn.classList.add('is-copied');
      var orig = btn.dataset.origText || btn.textContent.trim();
      btn.dataset.origText = orig;
      btn.textContent = 'Copied ✓';
      setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.textContent = orig;
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { done(); });
    } else {
      // Fallback for older browsers
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
  };

  /* ------- Init on DOM ready ------- */
  function init() {
    // Wire all [data-pomme-open] triggers
    document.querySelectorAll('[data-pomme-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        Pomme.openPopup(el.dataset.pommeOpen);
      });
    });
    // Wire all [data-pomme-close] triggers (close button or backdrop)
    document.querySelectorAll('[data-pomme-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        Pomme.closePopup(el.dataset.pommeClose);
      });
    });
    // Click on the mask itself closes the popup
    document.querySelectorAll('.pomme-popup-mask').forEach(function (mask) {
      mask.addEventListener('click', function (e) {
        if (e.target === mask) {
          Pomme.closePopup(mask.id);
        }
      });
    });
    // Esc to close any open popup
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.pomme-popup-mask.is-open').forEach(function (mask) {
          Pomme.closePopup(mask.id);
        });
      }
    });
    // Wire all [data-pomme-copy] code chips
    document.querySelectorAll('[data-pomme-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () { Pomme.copyCode(btn); });
    });
    // Le prune Shop Pay ne concerne que les pages avec bouton de paiement (PDP/panier) — inutile ailleurs (home/collection).
    if (!document.querySelector('.shopify-payment-button')) return;
    // Shop Pay only: hide dynamic checkout container if Shopify rendered something else (PayPal, etc.)
    // Strict detection — only the <shop-pay-button> web component counts as Shop Pay.
    function pruneNonShopPayButtons() {
      document.querySelectorAll('.shopify-payment-button').forEach(function (container) {
        var hasShopPay = container.querySelector('shop-pay-button');
        var hasContent = container.querySelector('iframe, button, [role="button"], shop-pay-button');
        if (hasContent && !hasShopPay) {
          container.style.display = 'none';
        } else if (hasShopPay) {
          container.style.display = '';
        }
      });
    }
    // Shopify renders dynamic button async (especially PayPal iframes — can take 2-3s).
    // Run aggressively for the first 5s, then stop.
    var pruneAttempts = 0;
    var pruneInterval = setInterval(function () {
      pruneNonShopPayButtons();
      if (++pruneAttempts >= 20) clearInterval(pruneInterval);
    }, 250);
    // Also observe DOM changes inside payment button containers for late renders.
    if ('MutationObserver' in window) {
      document.querySelectorAll('.shopify-payment-button').forEach(function (container) {
        var obs = new MutationObserver(pruneNonShopPayButtons);
        obs.observe(container, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   PDP mobile « partial » — galerie en défilement LIBRE.
   Swatch King (ré)initialise la galerie Flickity avec SES options à
   chaque changement de couleur ; après chaque (ré)création on impose :
   - freeScroll : le swipe est libre, aucune position prédéfinie
   - contain : bornes aux extrémités (1re photo collée à gauche au
     chargement, plus de blanc après la dernière)
   - cellAlign center conservé : un clic sur une VIGNETTE centre la
     photo (clampé par contain -> 1re à gauche, dernière à droite).
   Une loupe unique FIXE (bas-droite de la section) remplace les loupes
   par-photo, qui défileraient avec le carrousel libre.
   Mobile uniquement ; desktop inchangé.
   ============================================================ */
(function () {
  var MQ = '(max-width: 768px)';

  function applyGalleryOptions() {
    if (!window.Flickity || !window.matchMedia(MQ).matches) return;
    document.querySelectorAll('.grid--product-images--partial .product-slideshow.flickity-enabled').forEach(function (el) {
      var f = Flickity.data(el);
      if (!f) return;
      if (f.options.freeScroll === true && f.options.contain === true) return;
      f.options.freeScroll = true;
      f.options.freeScrollFriction = 0.075;
      f.options.contain = true;
      f.resize();
    });
  }

  function ensureZoomFab(wrap) {
    if (wrap.querySelector('.pomme-zoom-fab')) return;
    var anySlideZoom = wrap.querySelector('.js-photoswipe__zoom');
    if (!anySlideZoom) return;
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'btn btn--body btn--circle pomme-zoom-fab';
    fab.setAttribute('aria-label', 'Zoom');
    fab.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42"/></svg>';
    fab.addEventListener('click', function () {
      var sel = wrap.querySelector('.product-main-slide.is-selected .js-photoswipe__zoom') || wrap.querySelector('.js-photoswipe__zoom');
      if (sel) sel.click();
    });
    wrap.appendChild(fab);
  }

  function initGallery() {
    var wrap = document.querySelector('.grid--product-images--partial .product__main-photos');
    if (!wrap || !('MutationObserver' in window)) return;
    applyGalleryOptions();
    if (window.matchMedia(MQ).matches) ensureZoomFab(wrap);
    var pending = false;
    new MutationObserver(function () {
      // options appliquees SYNCHRONEMENT (microtask, avant le paint) : quand Swatch
      // King recree l'instance, aucune frame centree/non-contenue n'est peinte
      applyGalleryOptions();
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        applyGalleryOptions();
        if (window.matchMedia(MQ).matches) ensureZoomFab(wrap);
      });
    }).observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
